import { render } from "./OplAuthorizationSearchCriteria.vue?vue&type=template&id=0b2372da"
import script from "./OplAuthorizationSearchCriteria.vue?vue&type=script&lang=js"
export * from "./OplAuthorizationSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__